import { createFileRoute } from '@tanstack/react-router'
import { CoursesPopList } from '../../pages/Courses/CoursesPopList'

export const Route = createFileRoute('/(app)/_app/courses_/pop')({
  component: CoursesPopList,
})
